module.exports = __webpack_public_path__ + "static/media/loadingGIF2.426c8623.gif";